module.exports = __webpack_public_path__ + "static/guiding_boot_zelt.665625e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/guiding_boot_zelt.jpg
// module id = 1133
// module chunks = 35783957827783